import { hydrateRoot } from 'react-dom/client';
import { App } from './App';

// Гидратация SSR приложения на клиенте
const container = document.getElementById('root');
if (container) {
    hydrateRoot(container, <App />);
}
